import { Row } from "antd";
import errorHandler from "errorHandler";
import useLocationMetadata from "hooks/use-location-metadata";
import { useGetHolisticsTokenQuery } from "pacts/app-webcore/hasura-webcore.graphql";
import React, { useState } from "react";
import logger from "services/logger/logger";
import { LocationSubscription } from "utils/locationMetadata";
import "./SmartBEA.scss";

export type SmartBEAHolisticsBoardProps = {
  locationId: string;
  embedId?: string;
  filters?: any;
};

// Get dashboard embedIds from environment variables
const smartBEADashboardEmbedId =
  process.env.REACT_APP_HOLISTICS_SMART_BEA_DASHBOARD_EMBED_ID || "80bb302458d3fa68441614fe";
const smartREMDashboardEmbedId =
  process.env.REACT_APP_HOLISTICS_SMART_REM_DASHBOARD_EMBED_ID || "0d456d660fca66fcc6cd37f6";

const SmartBEAHolisticsBoard = ({ locationId, embedId, filters }: SmartBEAHolisticsBoardProps) => {
  const [holisticsPayload, setHolisticsPayload] = useState<string>("");
  const { locationMetadata } = useLocationMetadata({ locationId });

  // Determine which embed ID to use based on subscription
  const getEmbedId = (): string => {
    if (embedId) {
      return embedId; // Use provided embedId if available
    }

    const subscription = locationMetadata?.subscription;
    if (subscription === LocationSubscription.SMARTBEA) {
      return smartBEADashboardEmbedId;
    }
    if (subscription === LocationSubscription.SMART_REM) {
      return smartREMDashboardEmbedId;
    }

    // Default to SmartBEA if no subscription or unknown subscription
    return smartBEADashboardEmbedId;
  };

  const currentEmbedId = getEmbedId();

  useGetHolisticsTokenQuery({
    variables: { embedId: currentEmbedId, locationId, filters: filters ? JSON.stringify(filters) : null },
    onCompleted: (holisticsData) => {
      if (!holisticsData.getHolisticsToken || holisticsData.getHolisticsToken === "") {
        logger.warn("Dashboard token is empty for embedId:", currentEmbedId);
      }
      setHolisticsPayload(holisticsData.getHolisticsToken ?? "");
    },
    onError: errorHandler.handleError,
  });

  return (
    <div className="holistics-board-container">
      <Row>
        <iframe
          title="holistics embed"
          src={`https://secure.holistics.io/embed/${currentEmbedId}?_token=${holisticsPayload}`}
          id="embedded-iframe"
          width="100%"
          height="1200px"
          style={{ minHeight: "1200px", border: "none" }}
          className="holistics-iframe"
          allowFullScreen
        />
      </Row>
    </div>
  );
};

export default SmartBEAHolisticsBoard;
